import pxToRem from "hooks/usePxToRem";

import {Box, Grid} from "@mui/system";

import {DefaultCardStructure} from "components";
import {ModalityPayment, TypeKnowledge} from "util/globalEnums";
import {useFormContext, Controller} from "react-hook-form";
import ProcessTextField from "views/ProcessDetails/refactor/components/ProcessTextField";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {getProcessLabel} from "views/ProcessDetails/refactor/utils/processLabels";
import ProcessSelect from "views/ProcessDetails/refactor/components/ProcessSelect";
import {CustomToggle} from "ui";

const MasterInfoIA = () => {
  const {control, getValues, setValue} = useFormContext<Process>();

  const indexOfMaster = getValues("knowledges")?.findIndex(
    (knowledge) => knowledge.typeKnowledge === "Master",
  );

  /**
   * Caso o master não exista, o indexOfMaster será 0.
   */
  const masterIndex = indexOfMaster < 0 ? 0 : indexOfMaster;

  return (
    <DefaultCardStructure
      title={getProcessLabel("knowledge.master.title", getValues("modality"))}
      hasDivider={!!getValues(`knowledges.${masterIndex}.directMaster`)}
      isSubcard
    >
      <Grid container columnSpacing={pxToRem(3)}>
        <Grid size={6}>
          <Controller
            name={`knowledges.${masterIndex}.number`}
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name={`knowledges.${masterIndex}.number`}
                type="text"
                placeholder={getProcessLabel(
                  "knowledge.master.number",
                  getValues("modality"),
                )}
                value={value ?? ""}
                onChange={(e) => {
                  onChange(e.target.value);

                  setValue(
                    `knowledges.${masterIndex}.typeKnowledge`,
                    TypeKnowledge.Master,
                    {
                      shouldDirty: true,
                    },
                  );
                }}
                size="small"
                fullWidth
                label={getProcessLabel(
                  "knowledge.master.number",
                  getValues("modality"),
                )}
              />
            )}
          />
        </Grid>

        <Grid size={6}>
          <Controller
            name={`knowledges.${masterIndex}.paymentMethod`}
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessSelect
                name={`knowledges.${masterIndex}.paymentMethod`}
                value={value ?? ""}
                onChange={onChange}
                data={Object.values(ModalityPayment)}
                size="small"
                disabled
                fullWidth
                label="Modelo De Pagamento"
              />
            )}
          />
        </Grid>
        <Box
          sx={{
            marginTop: pxToRem(-4),
            maxHeight: pxToRem(32),
            ml: pxToRem(5),
          }}
        >
          <Controller
            name={`knowledges.${masterIndex}.directMaster`}
            control={control}
            render={({field: {onChange, value}}) => (
              <CustomToggle
                name={`knowledges.${masterIndex}.directMaster`}
                label={getProcessLabel(
                  "knowledge.master.directMaster",
                  getValues("modality"),
                )}
                labelPosition="end"
                onToggleSwitch={onChange}
                isChecked={!!value}
                isDisabled
              />
            )}
          />
        </Box>
      </Grid>
    </DefaultCardStructure>
  );
};

export default MasterInfoIA;
